import { Component, Vue } from "vue-property-decorator";
import { auth } from "@/config/host.config";
import { AxiosResponse } from "axios";

interface ICommand {
  key: string;
  value: string;
  updatetime: string; //default: now
  date: Date;
  manager_id: string;
}

@Component({})
export default class TvCommandsController extends Vue {
  async sendComands(command: ICommand, users: Array<string>): Promise<void> {
    const uri = auth.messages;
    const data = { users, command };
    try {
      const res: AxiosResponse<number> = await this.$axios.post(uri, data);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        return;
      }
    } catch (e) {
      console.error(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }
}
